// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AssetTradingMode, CalculationMethod } from '@shared/utils/Asset/AssetConst';
import { DataCacheHolder } from './DataCacheHolder';
export class AssetInfoData {
    constructor() {
        // Asset name
        this.Name = '';
        // Total qty
        this.TotalQuantity = 0;
        // Qty for margin available
        this.TotalQuantityForMarginAvailable = 0;
        this.AssetTradingMode = AssetTradingMode.Delivery;
        // Calculation method (0 - LAST, 1 - PREV_CLOSE)
        this.CalculationMethod = CalculationMethod.Last;
        // Today traded qty (передает один раз при логине, лдальше должны расчитывать сами)
        this.TodayTradedQty = 0;
    }
    GetCurrentValue(qty, account) {
        const asset = DataCacheHolder.getDataCache().GetAssetByName(this.Name);
        let lastPrice = NaN;
        let crossPrice = NaN;
        if (asset === null || asset === void 0 ? void 0 : asset.Instrument) {
            lastPrice = asset.Instrument.Level1.GetLastPrice(account);
            crossPrice = asset.Instrument.DataCache.CrossRateCache.GetCrossPriceExp1Exp2(asset.Instrument.Exp2, account.BaseCurrency, account);
        }
        if (isNaN(lastPrice) || isNaN(crossPrice)) {
            return NaN;
        }
        return qty * lastPrice * crossPrice;
    }
    GetAvailableQty() {
        return this.TodayTradedQty >= 0 ? this.TotalQuantity : this.TotalQuantity - Math.abs(this.TodayTradedQty);
    }
    // Current qty = Start day qty + Today traded qty. Причем оба слагаемых могут быть с разными знаками.
    GetCurrentQty() {
        return this.TotalQuantity + this.TodayTradedQty;
    }
}
